import IReport from './IReport';
import generateCSV from "../../services/CSVController";
import save from 'save-file';
import { denominatorToFull } from '../../utils/rawPrice';
import { toLocalDateTime } from '../../yoello-lib/modules/utils/TimeConversion';
import { TFunction } from 'i18next';

export interface IOrderLineItemDetailReport {
    created_on: string,
    serial_id: number,
    venue_name: string,
    hash_id: string,
    order_status: string,
    order_type: string,
    item_type: string,
    item_status: string,
    consumer_first_name: string,
    consumer_last_name: string,
    table_area: string | null,
    delivery_table: string,
    collection_point_name: string,
    delivery_datetime: string,
    collection_time: string,
    customer_note: string,
    menu_item_name_public: string,
    menu_item_name_private: string,
    product_type: string,
    pricing_option_name: string,
    subcategory_name: string,
    category_name: string,
    menu_name_public: string,
    menu_name_private: string | null,
    quantity: number,
    discount_code: string,
    discount_amount: number,
    sale_price_net: number,
    vat_amount: number,
    sale_price_gross: number,
    order_option: string,
    payment_method: string,
    asap_delivery_requested: boolean,
}
export default async function orderLineItemDetailReport(reportArray: IOrderLineItemDetailReport[] | undefined, reportObj: IReport, venueName: string, t?: TFunction) {
    /**If the stock report isn't undefined and the its greater than 0 try generate CSV */
    if (reportArray !== undefined && reportArray.length > 0) {
        const arrayOfKeys = ["created_on", "serial_id", "venue_name","hash_id","order_status","order_type","item_type","item_status",
            "consumer_name","table_area","delivery_table","collection_point_name","delivery_datetime","collection_time","customer_note","menu_item_name_public","menu_item_name_private",
            "product_type","pricing_option_name","subcategory_name","category_name","menu_name_public","menu_name_private",
            "quantity","discount_code","discount_amount","sale_price_net","vat_amount","sale_price_gross","order_option","payment_method"
        ];
        const arrayOfHeaders = ["Date/Time", "Venue ID", "Venue Name", "Order ID", "Order Status","Order Type", "Item Type","Item Status", "Customer Name", "Venue Area Name",
            "Venue Area Number", "Collection Point", "Delivery Time", "Collection Time", "Customer Note", "Product Name", "Internal Product Name", "Product Type", "Pricing Name", "Subcategory",
            "Category", "Menu Name", "Menu Name (Internal)", "Quantity", "Discount Code Used", "Total Discount Applied", "Total Sales Price (Net)", "Total Tax Amount", "Total Sales Price (Gross)", "Order Option", "Payment Method"];
        const mapStockReport = reportArray.map((stockObject) => {
            return {
                ...stockObject,
                created_on : toLocalDateTime(stockObject.created_on, "DD/MM/YYYY HH:mm"),
                delivery_datetime: 
                    stockObject.asap_delivery_requested && stockObject.delivery_datetime 
                    ? t?.('orderHistory.modal.Asap')
                    : stockObject.delivery_datetime 
                        ? toLocalDateTime(stockObject.delivery_datetime, "HH:mm") 
                        : null,
                collection_time:  
                    stockObject.asap_delivery_requested && stockObject.collection_time 
                        ? t?.('orderHistory.modal.Asap')
                        :stockObject.collection_time 
                            ? toLocalDateTime(stockObject.collection_time, "HH:mm") 
                            : null,
                consumer_name: `${stockObject.consumer_first_name} ${stockObject?.consumer_last_name ?? ''}`,
                discount_amount: denominatorToFull(stockObject.discount_amount),
                vat_amount: denominatorToFull(stockObject.vat_amount),
                sale_price_net: denominatorToFull(stockObject.sale_price_gross - stockObject.vat_amount),
                sale_price_gross: denominatorToFull(stockObject.sale_price_gross),
            };
        });
        const csvString = generateCSV(mapStockReport, arrayOfKeys, arrayOfHeaders);
        save(csvString, `${venueName}-detailed-line-item-report-from${reportObj.start_date_time}to${reportObj.end_date_time}.csv`);
        return;
    }
}